// hooks/useAppModal.ts
import { modals } from "@mantine/modals";
import { CrudModalInnerProps } from "components/ui/ConfirmModal/CRUDModal/CRUDModal";
import { ReactNode } from "react";

export const useAppModal = () => {
  const openCrudModal = (
    title: ReactNode | string,
    // Thêm onSuccess vào type
    props: CrudModalInnerProps & { onSuccess?: (data?: any) => void },
    modalSize: string | number = "md",
  ) => {
    const modalId = modals.openContextModal({
      modal: "crud",
      title,
      size: modalSize,
      innerProps: {
        ...props,
        // Override lại hành vi onSuccess: Đóng modal hiện tại trước, sau đó mới chạy callback
        onSuccess: (data: any) => {
          modals.close(modalId);
          if (props.onSuccess) props.onSuccess(data);
        },
        onClose: () => {
          modals.close(modalId);
        },
      },
    });

    return modalId;
  };

  const closeCrudModal = (modalId: string) => {
    return modals.close(modalId);
  };

  return { openCrudModal, closeAll: modals.closeAll, closeCrudModal };
};
